import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { buffetSelector } from 'store/slices/buffetSlice'
import { liffApiClient } from 'variables/services'
import { MAXIMUM_SHARE_COUPONS } from 'variables/dineIn'
import BaseShareCoupon from 'pages/dine-in/pages/ShareCoupon'
import ScrollPage from 'components/base-ui/ScrollPage'
import { CurrentUserCampaignDataPackDocument } from 'graphQL/hatostore/generate/operations'
import useCombineCoupon from 'hooks/buffet/useCombineCoupon'
import ModalLimitSharingCoupons from 'components/dine-in/modal/ModalLimitSharingCoupons'
import ModalConfirmCombineCoupon from 'components/dine-in/modal/ModalConfirmCombineCoupon'
import BuffetContainer from 'components/buffet/BuffetContainer'

const ShareCoupon = () => {
  const buffet = useSelector(buffetSelector)
  const { t } = useTranslation()
  const [processing, setProcessing] = useState(false)
  const scrollPageRef = useRef<HTMLDivElement>(null)
  const {
    handleClickCombineCoupon,
    confirmCombineCoupon,
    modalLimitSharingCoupons,
    modalCombineCoupons,
    toggleAlertLabel,
  } = useCombineCoupon()

  const handleRefresh = async () => {
    setProcessing(true)
    await liffApiClient.refetchQueries({ include: [CurrentUserCampaignDataPackDocument] })
    setProcessing(false)
  }

  return (
    <BuffetContainer>
      <ScrollPage id="share-coupon-page" ref={scrollPageRef}>
        <BaseShareCoupon
          orderId={buffet.table.orderID}
          onRefresh={handleRefresh}
          onClickCombineCoupon={handleClickCombineCoupon}
          processing={processing}
          allowedSharingCoupon={buffet.allowedSharingCoupon}
          toggleAlertLabel={toggleAlertLabel}
        />

        <ModalLimitSharingCoupons
          total={MAXIMUM_SHARE_COUPONS}
          isOpen={modalLimitSharingCoupons.open}
          onRequestClose={() => modalLimitSharingCoupons.setOpen(false)}
          btnAccept={{
            content: t('dineIn.modal.limitSharingCoupons.accept'),
            onClick: () => modalLimitSharingCoupons.setOpen(false),
          }}
        />

        <ModalConfirmCombineCoupon
          isOpen={modalCombineCoupons.open}
          onRequestClose={() => {
            modalCombineCoupons.setOpen(false)
          }}
          btnAccept={{
            content: t('dineIn.modal.shareCoupon.confirm'),
            isProcessing: modalCombineCoupons.processing,
            onClick: confirmCombineCoupon,
          }}
          btnCancel={{
            content: t('dineIn.modal.shareCoupon.cancel'),
            outline: true,
            onClick: () => modalCombineCoupons.setOpen(false),
          }}
        />
      </ScrollPage>
    </BuffetContainer>
  )
}

export default ShareCoupon
